import { createConsumer } from "@rails/actioncable";
export default createConsumer(window.Notify && window.Notify.cableUrl || "/notify_cable");
